// src/services/apiClient.js
import axios from "axios";
import { useAppStore } from "../stores/useAppStore";

// Base axios instance
const api = axios.create({
  withCredentials: true, // 🍪 IMPORTANT: send session cookie
  headers: { "Content-Type": "application/json" },
  timeout: 120000,
});

// Global 401 handler.
//
// The redirect-to-`/` is meant for the case where a user gets logged out
// mid-session while inside `/app/*`. We must skip it on public pages —
// otherwise a 401 at `/` (e.g. an `/auth/me` probe with no cookie) causes
// `window.location.href = "/"`, which reloads `/`, which probes again,
// which 401s, which redirects… until the API rate-limits at 429.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      useAppStore.getState().logout();
      const onPublicPage = !window.location.pathname.startsWith('/app');
      if (!onPublicPage) {
        window.location.href = '/';
      }
    }

    return Promise.reject(err);
  }
);

export default api;
